class DashboardController {
    constructor() {
        "ngInject";
    }

    public $onInit = () => {
        // console.log('DashboardController');
    }
}

export const dashboard = {
    controller: DashboardController,
    template: require('./dashboard.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.component.ts